import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { Window, Dialog, ConfirmDialog, EmptyState, Loading } from "../../components/VB";
import { toast } from "sonner";
import { Plus, Trash2, Settings } from "lucide-react";
import PoinKategori from "./PoinKategori";

export default function PoinKinerja() {
  const [items, setItems] = useState([]);
  const [emps, setEmps] = useState([]);
  const [kats, setKats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [showKat, setShowKat] = useState(false);
  const [form, setForm] = useState({ employee_id: "", kategori_id: "", nilai: 0, tanggal: new Date().toISOString().slice(0, 10), catatan: "" });
  const [del, setDel] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const [p, e, k] = await Promise.all([api.get("/poin"), api.get("/employees"), api.get("/poin-kategori")]);
      setItems(p.data); setEmps(e.data); setKats(k.data);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/poin", { ...form, nilai: parseFloat(form.nilai) });
      toast.success("Poin tersimpan");
      setOpen(false); load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  const doDelete = async () => {
    try { await api.delete(`/poin/${del.id}`); toast.success("Dihapus"); setDel(null); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  const empName = (id) => emps.find((e) => e.id === id)?.nama_lengkap || "-";
  const katName = (id) => kats.find((e) => e.id === id)?.nama || "-";

  if (showKat) return (
    <div>
      <button className="vb-btn" onClick={() => setShowKat(false)} style={{ marginBottom: 8 }}>← Kembali ke Input Poin</button>
      <PoinKategori />
    </div>
  );

  return (
    <Window
      title="Management Poin Kinerja"
      actions={
        <>
          <button className="vb-btn" onClick={() => setShowKat(true)} data-testid="manage-kat-btn"><Settings className="w-3 h-3 inline mr-1" />Kelola Kategori</button>
          <button className="vb-btn" onClick={() => setOpen(true)} data-testid="add-poin"><Plus className="w-3 h-3 inline mr-1" />Input Poin</button>
        </>
      }
    >
      {loading ? <Loading /> : items.length === 0 ? <EmptyState /> : (
        <table className="vb-table">
          <thead><tr><th>Tanggal</th><th>Karyawan</th><th>Kategori</th><th>Nilai</th><th>Catatan</th><th>Aksi</th></tr></thead>
          <tbody>
            {items.map((it) => (
              <tr key={it.id}>
                <td>{it.tanggal}</td><td>{empName(it.employee_id)}</td><td>{katName(it.kategori_id)}</td>
                <td>{it.nilai}</td><td>{it.catatan}</td>
                <td><button className="vb-btn-danger" style={{ padding: "2px 6px" }} onClick={() => setDel(it)} data-testid={`poin-del-${it.id}`}><Trash2 className="w-3 h-3" /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <Dialog open={open} onClose={() => setOpen(false)} title="Input Poin Karyawan"
        footer={<><button className="vb-btn" onClick={() => setOpen(false)}>Batal</button><button className="vb-btn-primary" onClick={submit} data-testid="poin-save">Simpan</button></>}>
        <form onSubmit={submit}>
          <div className="vb-form-row"><label className="vb-label">Karyawan*</label>
            <select className="vb-select" value={form.employee_id} onChange={(e) => setForm({ ...form, employee_id: e.target.value })} required data-testid="poin-employee">
              <option value="">- pilih -</option>
              {emps.map((e) => <option key={e.id} value={e.id}>{e.nama_lengkap}</option>)}
            </select></div>
          <div className="vb-form-row"><label className="vb-label">Kategori Poin*</label>
            <select className="vb-select" value={form.kategori_id} onChange={(e) => setForm({ ...form, kategori_id: e.target.value })} required data-testid="poin-kategori">
              <option value="">- pilih -</option>
              {kats.map((k) => <option key={k.id} value={k.id}>{k.nama} (max {k.max_poin})</option>)}
            </select></div>
          <div className="vb-form-row"><label className="vb-label">Nilai Poin*</label>
            <input type="number" className="vb-input" value={form.nilai} onChange={(e) => setForm({ ...form, nilai: e.target.value })} required step="any" data-testid="poin-nilai" /></div>
          <div className="vb-form-row"><label className="vb-label">Tanggal*</label>
            <input type="date" className="vb-input" value={form.tanggal} onChange={(e) => setForm({ ...form, tanggal: e.target.value })} required data-testid="poin-tanggal" /></div>
          <div className="vb-form-row"><label className="vb-label">Catatan</label>
            <textarea className="vb-textarea" rows={2} value={form.catatan} onChange={(e) => setForm({ ...form, catatan: e.target.value })} data-testid="poin-catatan" /></div>
        </form>
      </Dialog>

      <ConfirmDialog open={!!del} onClose={() => setDel(null)} onConfirm={doDelete} message="Yakin hapus poin ini?" />
    </Window>
  );
}
